export default {"src":"/_next/static/image/public/images/flags/flag_245.e36d6696e821e1608531563c64bf8385.svg","height":16,"width":24};